import { apiUrl } from './apiBase';

export async function saveNftTransformFmvOverrides(datasetId, year, overrides = []) {
  const response = await fetch(
    apiUrl(`/api/datasets/${datasetId}/nft-transform-fmv`),
    {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year: Number(year),
        overrides,
      }),
    }
  );

  const json = await response.json().catch(() => null);

  if (!response.ok || json?.success === false) {
    throw new Error(
      json?.message ||
        json?.error ||
        `Failed to save NFT transform FMV (${response.status})`
    );
  }

  return json;
}
